import { ROUTE_NAMES } from './routeNames.const'

export const routeTaxReturn = {
  path: '/taxReturn',
  component: () =>
    import(
      /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/TaxationTaxReturn.vue'
    ),
  children: [
    {
      path: 'balance',
      name: ROUTE_NAMES.taxation.taxReturn.balance,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationBalance.vue'
        ),
    },
    {
      path: 'civil-status',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.civilStatus,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationCivilStatus.vue'
        ),
    },
    {
      path: 'tax-situation',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.taxSituation,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationSituation.vue'
        ),
    },
    {
      path: 'dependant-persons',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.dependantPersons,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationDependantPersons.vue'
        ),
    },
    {
      path: 'connected-persons',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.connectedPersons,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationConnectedPersons.vue'
        ),
    },
    {
      path: 'address',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.address,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationAddress.vue'
        ),
    },
    {
      path: 'bank-details',
      name: ROUTE_NAMES.taxation.taxReturn.civilStatus.bankDetails,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationBankDetails.vue'
        ),
    },
    {
      path: 'withholding-tax',
      name: ROUTE_NAMES.taxation.taxReturn.withholdingTax,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationWithholdingTax.vue'
        ),
    },
    {
      path: 'business-income',
      name: ROUTE_NAMES.taxation.taxReturn.businessIncome.businessIncome,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationBusinessIncome.vue'
        ),
    },
    {
      path: 'wages',
      name: ROUTE_NAMES.taxation.taxReturn.businessIncome.wages,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationWages.vue'
        ),
    },
    {
      path: 'exempt-income',
      name: ROUTE_NAMES.taxation.taxReturn.businessIncome.exemptIncome,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationExemptIncome.vue'
        ),
    },
    {
      path: 'pensions',
      name: ROUTE_NAMES.taxation.taxReturn.businessIncome.pensions,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationPensions.vue'
        ),
    },
    {
      path: 'self-employed-workers',
      name: ROUTE_NAMES.taxation.taxReturn.businessIncome.selfEmployedWorkers,
      component: () =>
        import(
          /* webpackChunkName: "Taxation" */ 'src/pages/Taxation/TaxationTaxReturn/subViews/TaxationSelfEmployedWorkers.vue'
        ),
    },
  ],
}
